import { envConfig } from '../../envConfig'

const webUrlBase = envConfig.url.API_URL

export const urlCallWaiter = `${webUrlBase}api/mobile/tables/call_waiter`
export const urlStopCallWaiter = `${webUrlBase}api/mobile/tables/turnoff_call_waiter`